import { render, staticRenderFns } from "./discussList.vue?vue&type=template&id=6e7552c6&scoped=true"
import script from "./discussList.vue?vue&type=script&lang=js"
export * from "./discussList.vue?vue&type=script&lang=js"
import style0 from "./discussList.vue?vue&type=style&index=0&id=6e7552c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7552c6",
  null
  
)

export default component.exports